import { Action, AnyAction } from '../action.type';
import { AppState } from '../app.state';
import { CLOSE_SIDEBAR, OPEN_SIDEBAR } from './sidebar.action.type';

export const sidebarReducers = (
  state: AppState,
  action: AnyAction,
): AppState => {
  switch (action.type) {
    case OPEN_SIDEBAR:
      return openSidebarReducer(state, action);
    case CLOSE_SIDEBAR:
      return closeSidebarReducer(state, action);
    default:
      return state;
  }
};

const openSidebarReducer = (
  state: AppState,
  _action: Action<void>,
): AppState => {
  state.sidebar.isOpen = true;
  return state;
};

const closeSidebarReducer = (
  state: AppState,
  _action: Action<void>,
): AppState => {
  state.sidebar.isOpen = false;
  return state;
};
